const INSPIRATION = {
    ALL_DEVELOPMENTS: '1',
    ALL_CATEGORIES: '2',
    DONE_TYPING_INTERVAL: 500,
    SPACE: ' ',
    SPACE_REPLACEMENT: '-',
    APOSTROPHE: "'"
};
let InspirationComponent = {
    inspirationComponent: {},
    listCardComponent: {},
    paginationControls: {},
    controls: {
        developmentFilter: {},
        categoryFilter: {},
        inspirationSearch: {}
    },
    pageHeading: {},
    pageHeadingText: '',
    documentTitle: {},
    selectedDevelopmentName: '',
    selectedCategoryName: '',
    restSuccess: '',
    restError: '',
    queryString: '',
    filtersNoMatch: '',
    searchFiltersPlaceholder: '',
    typingTimer: '',
    init: function(componentContainer) {
        this.componentContainer = componentContainer;

        // get the inspiration filter controls
        this.controls.developmentFilter = document.getElementById('inspiration-filter--developments');
        this.controls.developmentFilter.addEventListener('change', (e) => {
            this.updateFilter(e.target, 'currentDevelopment');
        });
        this.controls.categoryFilter = document.getElementById('inspiration-filter--categories');
        this.controls.categoryFilter.addEventListener('change', (e) => {
            this.updateFilter(e.target, 'currentCategory');
        });
        this.controls.inspirationSearch = document.getElementById('inspiration-filter--search');
        this.controls.inspirationSearch.addEventListener('keyup', (e) => {
            clearTimeout(this.typingTimer);
    
            if (e.key !== 'Backspace') {
                if (e.target.value.length > 3) {
                    this.typingTimer = setTimeout(this.doneTyping, INSPIRATION.DONE_TYPING_INTERVAL);
                }
            } else {
                if (e.target.value.length > 3) {
                    this.typingTimer = setTimeout(this.doneTyping, INSPIRATION.DONE_TYPING_INTERVAL);
                }
                if (this.controls.inspirationSearch.value === '') {
                    this.typingTimer = setTimeout(this.doneTyping, INSPIRATION.DONE_TYPING_INTERVAL);
                }
            }
        });

        // get the list card component (there can only be one on a page)
        this.listCardComponent = document.getElementById('list-card-component');
        this.paginationControls = document.getElementById('pagination-wrapper');
        PaginatedListComponent.init(this.listCardComponent, this.paginationControls, this.showItems);

        this.getHiddenFieldValue('restSuccess', '.rest-message--success', false);
        this.getHiddenFieldValue('restError', '.rest-message--error', false);

        this.getInitialFilterState().then((state) => {

            let searchResultsNoMatchField = document.querySelector('.search-results-no-matches');
            if (searchResultsNoMatchField) {
                this.filtersNoMatch = `<div class="loader-title">${searchResultsNoMatchField.value}</div>`;
            }
    
            let searchFiltersPlaceholder = document.querySelector('.search-placeholder');
            if (searchFiltersPlaceholder) {
                this.searchFiltersPlaceholder = searchFiltersPlaceholder.value;
            }
            // Document Title
            let documentTitle = document.querySelector('TITLE');
            if (documentTitle) {
                this.documentTitle = documentTitle;
            }
    
            // Page Heading
            let pageHeading = document.querySelector('.page-title H1');
            if (pageHeading) {
                this.pageHeading = pageHeading;
                this.pageHeadingText = this.pageHeading.innerHTML;
            }

            this.showItems(PAGINATION.FIRST_PAGE).then( () => {
                history.replaceState(PaginatedListComponent.state, '', PaginatedListComponent.getURL());
            });
        });
    },
    getHiddenFieldValue: function(fieldName, querySelector, isStateField) {
        let field = document.querySelector(querySelector); 
        if (field) {
            if (isStateField) {
                PaginatedListComponent.state[fieldName] = field.value;
            } else {
                this[fieldName] = field.value;
            }
        }
    },
    getData: async function(useSavedState) {
        let data = {};
        if (useSavedState) {
            data.data = {
                inspirationItems: PaginatedListComponent.getQuerySet(),
                noOfItemsPerPage: PaginatedListComponent.getNumberOfItemsPerPage(),
                selectedPage: PaginatedListComponent.getPage(),
                tooltips: PaginatedListComponent.getButtonTooltips(),
                totalNoOfItems: PaginatedListComponent.getTotalNumberOfItems(),
                inspirationFilters: PaginatedListComponent.state.filtersQuerySet,    
                currentDevelopment: PaginatedListComponent.state.currentDevelopment,
                currentCategory: PaginatedListComponent.state.currentCategory,
                keyword: PaginatedListComponent.state.currentSearch
            };
        } else {
            let URL = `${APIPrefix.get()}/search_api/inspiration/inspiration?page=${PaginatedListComponent.getPage()}&noOfItemsPerPage=${PaginatedListComponent.getNumberOfItemsPerPage()}&selectedDevelopment=${PaginatedListComponent.state.currentDevelopment}&selectedCategory=${PaginatedListComponent.state.currentCategory}&queryString=${PaginatedListComponent.state.currentSearch}`;
            data = APIUtils.getComponentData(this.listCardComponent, URL, this.restSuccess, this.restError);
        }
        return data;
    },
    showItems: async function (page, useSavedState) {

        return new Promise((resolve) => {

            PaginatedListComponent.setPage(page);
            InspirationComponent.getData(useSavedState).then((response) => {
                let data = response.data;
                PaginatedListComponent.setPage(data.selectedPage);
                PaginatedListComponent.setTotalNumberOfItems(data.totalNoOfItems);
                PaginatedListComponent.setQuerySet(data.inspirationItems);
                PaginatedListComponent.setButtonTooltips(data.tooltips);

                PaginatedListComponent.state.filtersQuerySet = InspirationComponent.normalizeCategories(data.inspirationFilters);    
                PaginatedListComponent.state.currentDevelopment = data.currentDevelopment;
                PaginatedListComponent.state.currentCategory = data.currentCategory;
                PaginatedListComponent.state.currentSearch = data.keyword;
    
                if (data.inspirationItems !== undefined) {
                    InspirationComponent.buildListCardComponent();
                } else {
                    InspirationComponent.listCardComponent.innerHTML = InspirationComponent.filtersNoMatch;
                }
                InspirationComponent.getSelectedFilterNames();
                InspirationComponent.setDocumentTitle();
                InspirationComponent.setInspirationPageHeading();
                PaginatedListComponent.setQueryString(InspirationComponent.getPageURL());
                InspirationComponent.buildInspirationFilters();
                PaginatedListComponent.adjustListCardComponentHeight();
                PaginatedListComponent.clearControls();
                if (PaginatedListComponent.getNumberOfPages() > 1) {
                    PaginatedListComponent.pageButtons();
                }

                resolve(response.data);
            })
            .catch((e) => console.log(e));

        });

    },
    updateFilter: function(field, filterName) {
        let selected = field[field.selectedIndex].value;
        if (selected !== PaginatedListComponent.state[filterName]) {
            PaginatedListComponent.state[filterName] = selected;
            this.updateInspirationItems();
        }
    },
    // possibly move to paginated list component
    updateInspirationItems: function () {
        this.showItems(PAGINATION.FIRST_PAGE).then((res) => {
            history.pushState(PaginatedListComponent.state, '', PaginatedListComponent.getURL());
        });
    },
    doneTyping: function () {
        PaginatedListComponent.state.currentSearch = InspirationComponent.controls.inspirationSearch.value;
        InspirationComponent.updateInspirationItems();
    },
    buildListCardComponent: function() {
        let items = PaginatedListComponent.getQuerySet();
        let listHTML = '';
        items.forEach((item) => {
            listHTML = `${listHTML}${this.buildInspirationCard(item)}`;
        });
        this.listCardComponent.innerHTML = listHTML;
    },
    buildInspirationCard: function(item) {
        return `
            <div class="card_item inspiration-article-item">
                <a href="${item.linkHref}" title="${item.title}"><img class="img--responsive" width="385" alt="${item.title}" src="${item.imageUrl}"></a>
                <div class="inspiration-article-content">
                    <h3><a href="${item.linkHref}">${item.title}</a></h3>
                    <p>${item.date}</p>
                    <div>${item.description}</div>
                    <a class="button  button--link" title="${item.linkTooltip}" href="${item.linkHref}">${item.linkText}</a>
                </div>
            </div>
        `;
    },
    buildInspirationFilters: function() {
        let filters = PaginatedListComponent.state.filtersQuerySet;
        InspirationComponent.controls.developmentFilter.innerHTML = InspirationComponent.buildDevelopmentFilter(filters);
        InspirationComponent.controls.categoryFilter.innerHTML = InspirationComponent.buildCategoryFilter(filters);
    
        //Placeholder
        InspirationComponent.controls.inspirationSearch.setAttribute('placeholder', InspirationComponent.searchFiltersPlaceholder);
        InspirationComponent.controls.inspirationSearch.value = PaginatedListComponent.state.currentSearch;
    },
    buildDevelopmentFilter(filters) {
        return InspirationComponent.buildFilterOptionsHTML(filters.developments, 'currentDevelopment');
    },
    normalizeCategories: function(filters) {
        let normalizedCategories = [];
        // category groups go here
        for (const [group, categories] of Object.entries(filters.categories.menuGroups)) {
            normalizedCategories.push(...categories);
        }
        filters.normalizedCategories = normalizedCategories;
        return filters;
    },
    buildCategoryFilter: function(filters) {
        let filterHTML = '';

        filters.categories.topMenuItem.forEach((filter) => {
            filterHTML = `${filterHTML}<option value="${filter.id}" ${PaginatedListComponent.state.currentCategory === filter.id ? 'selected' : ''}>${filter.opt}</option>`;
        });

        // category groups go here
        for (const [group, categories] of Object.entries(filters.categories.menuGroups)) {
            if (categories.length) {
                // API returns the Group name with the first character  in lower case, uppercase it
                let groupName = group.charAt(0).toUpperCase() + group.slice(1);
                let developmentFilterHTML = InspirationComponent.buildFilterOptionsHTML(categories, 'currentCategory');
                filterHTML = `${filterHTML}<optgroup label="${groupName}">${developmentFilterHTML}</optgroup>`;
            }
        }

        return filterHTML;
    },
    buildFilterOptionsHTML: function(filters, currentStateField) {
        let filterHTML = '';
        if (filters.length) {
            filters.forEach((filter) => {
                filterHTML = `${filterHTML}<option value="${filter.id}" ${PaginatedListComponent.state[currentStateField] === filter.id ? 'selected' : ''}>${filter.opt}</option>`;
            });
        }
        return filterHTML;
    },

    getSelectedFilterNames: function() {

        let filters = PaginatedListComponent.state.filtersQuerySet;

        let selectedDevelopment = [];
        if (PaginatedListComponent.state.currentDevelopment !== INSPIRATION.ALL_DEVELOPMENTS) {
            selectedDevelopment =  filters.developments.filter((development) => development.id === PaginatedListComponent.state.currentDevelopment);
        }
        InspirationComponent.selectedDevelopmentName = selectedDevelopment.length ? selectedDevelopment[0].opt : '';

        let selectedCategory = [];
        if (PaginatedListComponent.state.currentCategory !== INSPIRATION.ALL_CATEGORIES) {
            selectedCategory = filters.normalizedCategories.filter((category) => category.id === PaginatedListComponent.state.currentCategory );
        }
        InspirationComponent.selectedCategoryName = selectedCategory.length ? selectedCategory[0].opt : '';

    },

    setInspirationPageHeading: function() {

        let pageHeadingText = InspirationComponent.pageHeadingText;

        if (InspirationComponent.selectedDevelopmentName.length) {
            pageHeadingText = `${pageHeadingText} from ${InspirationComponent.selectedDevelopmentName}`;
        }

        if (InspirationComponent.selectedCategoryName.length) {
            pageHeadingText = `${pageHeadingText} - ${InspirationComponent.selectedCategoryName}`;
        }

        InspirationComponent.pageHeading.innerHTML = pageHeadingText;
        
    },
    setDocumentTitle: function() {
        let documentTitleText = InspirationComponent.pageHeadingText;
        let documentTitleTextSuffix = 'Berkeley Group'; 

        if (InspirationComponent.selectedDevelopmentName.length) {
            documentTitleText = `${documentTitleText} from ${InspirationComponent.selectedDevelopmentName}`;
        }

        if (InspirationComponent.selectedCategoryName.length) {
            documentTitleText = `${documentTitleText} - ${InspirationComponent.selectedCategoryName}`;
        }

        InspirationComponent.documentTitle.innerHTML = `${documentTitleText} | ${documentTitleTextSuffix}`;
        
    },

    getPageURL: function() {

        let params = [];

        if (InspirationComponent.selectedDevelopmentName.length) {
            params.push(`development=${InspirationComponent.selectedDevelopmentName}`);
        }

        if (InspirationComponent.selectedCategoryName.length) {
            params.push(`category=${InspirationComponent.selectedCategoryName}`);
        }

        if (PaginatedListComponent.state.currentSearch.length) {
            params.push(`inspiration-search=${PaginatedListComponent.state.currentSearch}`);
        }

        let queryString = params.join('&');

        if (queryString.length) {
            queryString = `?${queryString.replaceAll(INSPIRATION.SPACE, INSPIRATION.SPACE_REPLACEMENT).replaceAll(INSPIRATION.APOSTROPHE,'')}`;
        }
        return queryString;
    },

    getFilterData: async function() {
        // get the filter data
        let URL = `${APIPrefix.get()}/search_api/inspiration/inspirationAllFilters`;
        let data = APIUtils.getData(URL);
        return data;
    },
    getInitialFilterState: async function() {
        return new Promise((resolve) => {
            PaginatedListComponent.state.currentDevelopment = INSPIRATION.ALL_DEVELOPMENTS;
            PaginatedListComponent.state.currentCategory = INSPIRATION.ALL_CATEGORIES;
            PaginatedListComponent.state.currentSearch = '';

            // check for server side brand parameter
            let developmentField = document.querySelector('.redirect-page');
            if (developmentField) {
                PaginatedListComponent.state.currentDevelopment = developmentField.value;
            }

            // check for url Search Parameters
            let paramsString = window.location.search;
            if (paramsString.length) {
                this.getFilterData().then((response) => {
                    let filters = InspirationComponent.normalizeCategories(response.data);
                    let searchParams = new URLSearchParams(paramsString.toLowerCase());
                    InspirationComponent.checkSearchParam(searchParams, 'development', 'currentDevelopment', filters.developments, INSPIRATION.ALL_DEVELOPMENTS);
                    InspirationComponent.checkSearchParam(searchParams, 'category', 'currentCategory', filters.normalizedCategories, INSPIRATION.ALL_CATEGORIES);
                    if (searchParams.has('inspiration-search')) {
                        PaginatedListComponent.state.currentSearch = searchParams.get('inspiration-search').replaceAll(INSPIRATION.SPACE_REPLACEMENT, INSPIRATION.SPACE);
                    }
                    resolve(PaginatedListComponent.state);
                });
            } else {
                // return the default state
                resolve(PaginatedListComponent.state);
            }
        });
    },
    checkSearchParam: function(searchParams, key, stateKey, options, defaultValue) {
        if (searchParams.has(key)) {
            let value = searchParams.get(key).replaceAll(INSPIRATION.SPACE_REPLACEMENT, INSPIRATION.SPACE);
            let selected = options.filter((option) => value === option.opt.toLowerCase().replaceAll(INSPIRATION.APOSTROPHE,'').replaceAll(INSPIRATION.SPACE_REPLACEMENT, INSPIRATION.SPACE));
            PaginatedListComponent.state[stateKey] = selected.length ? selected[0].id : defaultValue;
        }
    }

};

// Check for News Article component initialise if we have one 
document.addEventListener("DOMContentLoaded", function () {
    const inspirationComponent = document.querySelector('.inspiration-component');
    if (inspirationComponent) {
        InspirationComponent.init(inspirationComponent);
    }
});
